import { Events } from "@type-r/models";
import { Linked, useLinked } from "@type-r/react";
import { asCurrency, asDate, asTimelessDate, CompactTextArea, Flex, PopupIODialog, SelectFile, toLinkedBoolean } from 'lqx-react';
import * as React from 'react';
import { movePaymentTo, Payment, Transaction, TransactionCurrentType } from "src/app/pages/inmatch/api";
import { CustomerSupplier, RowH1, RowH2, RowH3 } from "../../../../../../common/inmatch";

const titles = {
    'ar': 'Move to Inmatch',
    'nonar': 'Move to Non-AR',
    'uac': 'Assign as UAC'
};


export const ArMoveDialog = ({ $payment, moveTo, paymentMoved } : {
    $payment : Linked<Payment | Transaction>,
    moveTo: TransactionCurrentType;
    paymentMoved: (paymentId: number) => void
}) => {

    const $isOpen = toLinkedBoolean($payment);
    const payment = $payment.value;
    const title = titles[moveTo];

    const $reason = useLinked('');
    const $file = useLinked(null);
    
    return (
        <PopupIODialog
            title={ title }
            actionLabel={ title }
            $isOpen={ $isOpen }
            success="Payment moved"
            doIO={ async () => {
                const paymentId = payment.id as any as number;

                const updated = await movePaymentTo(moveTo, paymentId, $file.value, $reason.value);

                if (updated) {
                    paymentMoved(paymentId);
                    Events.trigger('bankTransactionSummary:refresh');
                }
            }} >
                {
                    payment && !payment._disposed ?
                        <Flex column>
                            {
                                payment instanceof Payment && payment.matchesAggregation && payment.matchesAggregation.count > 0
                                    ? <RowH2 error={[]}>All invoices will be unmatched from this payment!</RowH2>
                                    : null
                            }

                            <CustomerSupplier customer={ payment.customer } supplier={ payment.supplier } />

                            <RowH1> { asCurrency( payment.unreconciledAmount, payment.currency ) } </RowH1>
                            <RowH2> Statement Date: { asTimelessDate( payment.statementDate ) } </RowH2>
                            <RowH3> Value Date: { asTimelessDate( payment.valueDate ) } </RowH3>

                            <CompactTextArea autoFocus label="Reason" rows={5} $value={ $reason }/>
                            <SelectFile accept=".csv,.edi,.xml,.txt,.json,.pdf,.xls,.doc,.docx,.xlsx,.png,.jpeg,.msg" label="ATTACHMENT" $value={ $file } />

                        </Flex>
                    : undefined
                }
        </PopupIODialog>
    );
}
